module.exports = {EH_ScheduledWatercraft_ItemMotorHorsepower:'Accumulate total horsepower if two or more engines or motors are regularly used together'}